import { Component, OnInit, ViewChild } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { LockerTableComponent } from "./locker-table/locker-table.component";

@Component({
	selector: "app-locker-maintenance",
	templateUrl: "./locker-maintenance.component.html",
	styleUrls: ["./locker-maintenance.component.css"],
})
export class LockerMaintenanceComponent implements OnInit {
	constructor(private selectService: SchoolselectorService) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////////////////////

	@ViewChild(LockerTableComponent)
	mainRef: LockerTableComponent;

	subscription: any;

	School: any;
	SelectedLocker: any;

	errorMessage: any = "";

	////////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////////////////////////
	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;
	}

	onSelectedLockerChanged(val) {
		//
		// Only update if the 1st item in the list has changed
		//
		if (val != this.SelectedLocker) {
			this.SelectedLocker = val;
		}
	}

	//
	// Update Main table when comments are changed
	//
	onUpdateParent(val) {
		var SelectedLocker = val[0];
		var LockerPerson = val[1];

		for (var z = 0; z < this.mainRef.lstLocker.length; z++) {
			var next = this.mainRef.lstLocker[z];

			if (next.LockerID == SelectedLocker.LockerID) {
				//
				// Only update if the current assigned comments were changed
				// (Don't update if editing old comments)
				//
				if (next.CurrentLockerPersonID == LockerPerson.LockerPersonID) {
					next.AssignedComments = LockerPerson.Comments;
				}

				//
				// Break after the correct locker is found (whether it gets updated or not)
				//
				break;
			}
		}
	}

	////////////////////////////////////////////////////////////////////////////////////////
}
